import { useAtomValue } from 'jotai';
import { FC, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { $DiscoverClassifyHotWords } from 'shared/atoms';
import { $CurrentDiscoverKeyword } from '../../shared/atom';
import { HotKeywordItem } from './hot-keyword-item';
import { useViewTracking } from '~/utils/use-view-tracking';
import { ClickPosition } from '~/utils/click-position';

import './style.scss';

export const HotKeywordsModule: FC = () => {
  const keyword = useAtomValue($CurrentDiscoverKeyword);

  const { recommendClassifyKepWord: keywordsList = [] } = useAtomValue($DiscoverClassifyHotWords(keyword as string));
  const { t } = useTranslation();

  if (keywordsList.length === 0) {
    return null;
  }

  const kepHotKeywordObservedRef = useViewTracking<HTMLDivElement>({
    onView: useCallback(() => {
      window.Tea('wap_module_show', {
        current_page_module: ClickPosition.kep_classify_hot_keyword,
        module_rank: 4, // fixed position
      });
    }, []),
  });

  const evenKeywordsList = keywordsList.length % 2 === 0 ? keywordsList : keywordsList.slice(0, -1);

  return (
    <div className="kep-hot-keywords-module" ref={kepHotKeywordObservedRef}>
      <div className="kep-hot-keywords-module-title">{`🔍 ${t('seo_popular_keyword_title')}`}</div>
      <div className="kep-hot-keywords-module-list">
        {evenKeywordsList.map((word, index) => {
          return <HotKeywordItem key={word} word={word} index={index} />;
        })}
      </div>
    </div>
  );
};
